function fadeInPanelOnScroll(fadeInPanel, thresholdPx) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            setTimeout(function () {
                fadeInPanel.dataset.panelFade = 'true';
            }, 150);
            observer.unobserve(fadeInPanel);
        }
    }, { rootMargin: `0px 0px -${thresholdPx}px 0px` });

    observer.observe(fadeInPanel);
}

function getThresholdPx() {
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (window.matchMedia("(max-width: 1024px)").matches) {
        return 3 * rem;
    } else {
        return 6.5 * rem;
    }
}

window.addEventListener('load', () => {
    const fadeInPanels = document.querySelectorAll('[data-panel-fade]');
    const thresholdPx = getThresholdPx();

    for (let fadeInPanel of fadeInPanels) {
        fadeInPanelOnScroll(fadeInPanel, thresholdPx);
    }

    // Update observers on window resize to handle dynamic threshold changes
    window.addEventListener('resize', () => {
        const newThresholdPx = getThresholdPx();
        for (let fadeInPanel of fadeInPanels) {
            // Reinitialize observer with the new threshold
            fadeInPanelOnScroll(fadeInPanel, newThresholdPx);
        }
    });
});
